import { Box, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { RISR, VerificacaoHidrologica } from '../../../../services/api/reports/ReportsServicesRisr';

interface HydrologicalCheckProps {
    dataRisr?: RISR
    onDataChange: (data: VerificacaoHidrologica) => void;
}

export const HydrologicalCheckRisr = ({ dataRisr, onDataChange }: HydrologicalCheckProps ) => {

    
    const [data, setData] = useState<VerificacaoHidrologica>({});
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        if (dataRisr?.verificacaoHidrologica && Object.keys(dataRisr.verificacaoHidrologica).length > 0) {
            setData(dataRisr.verificacaoHidrologica);
        }
    }, [dataRisr]);

    useEffect(() => {
        onDataChange(data);
    }, [data, onDataChange]);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { id, value } = e.target;
        setData(prevData => ({
            ...prevData,
            [id]: value
        }));
    };    

    return (
        <Box>
            <Grid>
                <Grid container marginBottom={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Verificação hidrológica/hidráulica</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Área de drenagem (km²)'
                            value={data?.area_drenagem || ''}
                            id='area_drenagem'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Precipitação'
                            value={data?.precipitacao_pmp || ''}
                            id='precipitacao_pmp'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Precipitação de projeto (mm)'
                            value={data?.precipitacao_projeto || ''}
                            id='precipitacao_projeto'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Duração crítica da chuva de projeto (min)'
                            value={data?.duracao_chuva || ''}
                            id='duracao_chuva'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Vazão máxima afluente (m³/s)'
                            value={data?.vazao_maxima || ''}
                            id='vazao_maxima'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='NA máximo operacional (m)'
                            value={data?.na_maximo_operacional || ''}
                            id='na_maximo_operacional'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='NA máximo maximorum (m)'
                            value={data?.na_maximo_maximorum || ''}
                            id='na_maximo_maximorum'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Borda livre (m)'
                            value={data?.borda_livre || ''}
                            id='borda_livre'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Sistema de bombeamento (quantidade e capacidade)'
                            value={data?.bombeamento || ''}
                            id='bombeamento'
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};